import { useContext } from 'react';
import i18nContext from 'components/i18n-context';
import './PaymentsCutoffTimesTableHeadRow.scss';

export const PAYMENTS_CUTOFF_TIMES_TABLE_HEADER = [
  {
    label: 'paymentMethod'
  },
  {
    label: 'workingHoursFrom'
  },
  {
    label: 'workingHoursTo'
  },
  {
    label: 'nonWorkingDays'
  }
];

const PaymentsCutoffTimesTableHeadRow = () => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {PAYMENTS_CUTOFF_TIMES_TABLE_HEADER.map((head) => (
        <th key={head.label} className={'payments-cutoff-times-table-head'}>
          <div className={'payments-cutoff-times-table-head-block'}>
            <span>{i18n.getMessage(`settings.paymentsCutoffTimes.table.header.${head.label}`)}</span>
          </div>
        </th>
      ))}
    </tr>
  );
};

export default PaymentsCutoffTimesTableHeadRow;
